import {
    addDoc,
    collection,
    CollectionReference,
    doc,
    DocumentData,
    DocumentReference,
    enableIndexedDbPersistence,
    Firestore,
    getDoc,
    getDocs,
    initializeFirestore,
    query,
    setDoc,
    where,
    getFirestore,
    orderBy, onSnapshot
} from 'firebase/firestore';
import { FirebaseApp, initializeApp, getApp } from 'firebase/app';
import { getAuth , signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, updateProfile} from "firebase/auth";
import fb from "../../../chat/firebase/init.js";

const state = {
    fireStore: null,
    app: null,
    fireAuth: null,
    allClientMessages: [],
    allChatAgentMessages: [],
    allWatchedMessagesByChatAgent: [],
    originalClientMessages: [],
    choosenChats: [],
    collection: {},
    timeIntervalLowerLimit: 1,
    timeIntervalUpperLimit: 0,
};

const getters = {
    getFireStore(state) {
        return state.fireStore;
    },
    getTimeIntervalLowerLimit(state) {
        return state.timeIntervalLowerLimit;
    },
    getTimeIntervalUpperLimit(state) {
        return state.timeIntervalUpperLimit;
    },
    getCollection(state) {
        return state.collection;
    },
    getFireApp(state){
        return state.app;
    },
    getFireAuth(state) {
      return state.fireAuth;
    },
    getAllClientMessages(state) {
      return state.allClientMessages;
    },
    getAllChatAgentMessages(state) {
      return state.allChatAgentMessages;
    },
    getAllWatchedMessagesByChatAgent(state) {
      return state.allWatchedMessagesByChatAgent;
    },
    getOriginalClientMessages(state) {
      return state.originalClientMessages;
    }
};

const mutations = {
    setFbApp(state, app) {
        state.app = app;
    },
    setTimeIntervalLowerLimit(state, timeIntervalLowerLimit) {
        state.timeIntervalLowerLimit = timeIntervalLowerLimit;
    },
    setTimeIntervalUpperLimit(state, timeIntervalUpperLimit) {
        state.timeIntervalUpperLimit = timeIntervalUpperLimit;
    },
    setCollection(state, collecton) {
        state.collection = collecton;
    },
    setFireStore(state, store) {
        state.fireStore = store;
    },
    setFireAuth(state, auth) {
        state.fireAuth = auth;
    },
    setAllClientMessages(state, messages) {
        state.allClientMessages = messages;
    },
    setAllChatAgentMessages(state, messages) {
        state.allChatAgentMessages = messages;
    },
    setAllWatchedMessagesByChatAgent(state, messages) {
        state.allWatchedMessagesByChatAgent = messages;
    },
    setOriginalClientMessages(state, messages) {
        state.originalClientMessages = messages;
    }
};

const actions = {
    async authUser(ctx, config) {
        const app = ctx.state.app;
        const auth = getAuth(app);
        const username = (config.isAdmin) ? config.originalUserId + '-' + 'admin@hutter-unger.de' : config.originalClientId + '-' + config.originalUserId + 'admin@hutter-unger.de';
        return signInWithEmailAndPassword( auth, username, config.clientId + config.userId).catch((error) => {
            createUserWithEmailAndPassword(auth, username, config.clientId + config.userId).catch((error) => {
                console.log(error)
            }).then((userCredentials) => {
                updateProfile( userCredentials.user, {displayName: (config.isAdmin) ? "isAdmin" : config.clientId}).then(result => {
                    signOut(auth).then(() => {
                        signInWithEmailAndPassword(auth, username, config.clientId + config.userId).then(result => {
                        })
                    });
                });
            });
        }).then((userCredentials) => {
            if (userCredentials && userCredentials.user && !userCredentials.user.displayName){
                console.log('No username detected. Updating Profile.');
                updateProfile( userCredentials.user, {displayName: (config.isAdmin) ? "isAdmin" : config.clientId}).then(result => {
                    signOut(auth).then(() => {
                        signInWithEmailAndPassword(auth, username, config.clientId + config.userId);
                    });
                });
            }
        });
    },
    async signOut(ctx) {
        const app = ctx.state.app;
        const auth = getAuth(app);
        if (app !== null) {
            return signOut(auth);
        }
    },
    async changeApp(ctx, store) {
        ctx.commit('setFbApp', getApp(store.config.appId));
        ctx.commit('setFireAuth', getAuth(state.app))
        await ctx.dispatch('signOut');
        ctx.commit('setFireStore', store);
        await ctx.dispatch('authUser', store.credentials);
        ctx.commit('setAllClientMessages', []);
    },

    async setFbConfig(ctx, payload) {
        await ctx.dispatch('changeApp', fb(payload.firebaseConfig, payload.configCredentials)).then(() => {
            getAuth(ctx.getters.getFireApp).onAuthStateChanged((user) => {
                if (user && user.displayName) {
                    console.log('Valid user profile is ready.');
                    ctx.commit('setCollection', collection(ctx.getters.getFireStore.store, payload.configCredentials.clientId.toString()));
                    ctx.dispatch('getAllClientChats')
                    ctx.dispatch('getUserChats', payload.configCredentials.userId)
                } else {
                    console.log('User profile needs configuration.');
                }
            })
        })
    },
    getAllClientChats: async function (ctx) {
        let collection = ctx.getters.getCollection;

        let q = query(collection,
            where('lastStatusUpdateTimestamp', '>=', moment().subtract(ctx.getters.getTimeIntervalLowerLimit, 'd').unix() * 1000),
            orderBy('lastStatusUpdateTimestamp', "desc"));

        if (this.timeIntervalUpperLimit !== 0) {
            q = query(collection,
                where('lastStatusUpdateTimestamp', '>=', moment().subtract(ctx.getters.getTimeIntervalLowerLimit, 'd').unix() * 1000),
                where('lastStatusUpdateTimestamp', '<=', moment().subtract(ctx.getters.getTimeIntervalUpperLimit, 'd').unix() * 1000),
                orderBy("lastStatusUpdateTimestamp", "desc"));
        }

        const unsubscribe = onSnapshot(q, async (querySnapshot) => {
            ctx.commit('setAllClientMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
            ctx.commit('setOriginalClientMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
        });
    },
    getUserChats: function (ctx, userId) {
        let collection = ctx.getters.getCollection;

        let userProcessedChatsQuery = query(collection,
            where("userId", "==", userId),
            where('status', "==", "processed"));

        let userWatchedChatsQuery = query(collection, where("watchers", "array-contains", userId.toString()));

        // Get all chats 1 by chatagent
        const subscriptionProccessed = onSnapshot(userProcessedChatsQuery, async (querySnapshot) => {
            ctx.commit('setAllChatAgentMessages', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
        });
        // Get all chats watched by chatagent
        const subscriptionWatched = onSnapshot(userWatchedChatsQuery, async (querySnapshot) => {
            ctx.commit('setAllWatchedMessagesByChatAgent', querySnapshot.docs.map(doc => Object.assign({}, {documentId: doc.id, ...doc.data()})));
        });
    },
};

export default  {
    state,
    getters,
    mutations,
    actions
}
